import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _get from 'lodash/get';
import _isArray from 'lodash/isArray';
import _isEmpty from 'lodash/isEmpty';
import _isNil from 'lodash/isNil';
import _isNumber from 'lodash/isNumber';
import _isObject from 'lodash/isObject';
import { DEFAULT_AUTO_SCROLL_INTERVAL, DEFAULT_SLIDE_DURATION_MS, SHOW_INDICATORS_THRESHOLD } from './constants';
import useResponsive from '../../../../../hooks/use-responsive';
import { toArray } from '../../../../../services/components';
import { classNames } from '../../../../../utils/classname';
export function getAutoScrollInterval(autoScroll, _ref) {
  var pageSize = _ref.pageSize,
    items = _ref.items;
  if (_isEmpty(items) || items.length <= pageSize) {
    return null;
  }
  if (!_isObject(autoScroll) && !autoScroll) {
    return null;
  }
  if (!_isObject(autoScroll) && autoScroll) {
    return DEFAULT_AUTO_SCROLL_INTERVAL;
  }
  return _get(autoScroll, 'interval', DEFAULT_AUTO_SCROLL_INTERVAL);
}
export function getPageSize(items, size, responsive) {
  var mobile = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var displayAllMobile = mobile.displayAll,
    mobileSize = mobile.size;
  var _useResponsive = useResponsive(),
    isMobile = _useResponsive.isMobile,
    isTablet = _useResponsive.isTablet;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  if (isMobile) {
    if (!_isNil(mobileSize) && _isNumber(mobileSize)) {
      return Math.min(mobileSize, itemsLength);
    }
  }
  if (responsive) {
    if (isMobile) {
      return displayAllMobile ? itemsLength : 1;
    }
    if (isTablet) {
      return Math.min(2, size, itemsLength);
    }
  }
  return Math.min(itemsLength, size);
}
export function getStepSize(items, size, stepSize) {
  var grouping = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  if (_isNil(stepSize) && grouping === 1) {
    return null;
  }
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  var pageSize = Math.min(size, itemsLength);
  if (_isNil(stepSize)) {
    return pageSize;
  }
  return Math.min(stepSize, pageSize);
}
export function showIndicators(pageSize, items) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref2$threshold = _ref2.threshold,
    threshold = _ref2$threshold === void 0 ? SHOW_INDICATORS_THRESHOLD : _ref2$threshold;
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  return itemsLength / pageSize < threshold;
}
export function displayCarouselControls(pageSize, items) {
  var itemsArray = toArray(items);
  var itemsLength = itemsArray.length;
  return itemsLength > pageSize;
}
export function getElementKey() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var key = element.key,
    _element$props = element.props,
    props = _element$props === void 0 ? {} : _element$props;
  var _ref3 = props || {},
    children = _ref3.children;
  if (!_isEmpty(key)) {
    return key;
  }
  if (!_isEmpty(children)) {
    if (children.key) {
      return children.key;
    }
    if (_isArray(children)) {
      var childrenKey = children.map(function (_ref4) {
        var k = _ref4.key;
        return k;
      }).filter(Boolean);
      if (!_isEmpty(childrenKey)) {
        return childrenKey.join('_');
      }
    }
  }
  return JSON.stringify(element);
}
export function getSlidingCarouselElementStyle(_ref5) {
  var index = _ref5.index,
    activePage = _ref5.activePage,
    previousPage = _ref5.previousPage,
    nextPage = _ref5.nextPage,
    pageSize = _ref5.pageSize;
  var currentPage = Math.floor(index / pageSize) + 1;
  var hidden = ![nextPage, previousPage, activePage].includes(currentPage);
  var active = !hidden;
  var current = currentPage === activePage;
  var next = currentPage === nextPage;
  var previous = currentPage === previousPage;
  var className = classNames({
    'sliding-element': true,
    hidden: hidden,
    active: active,
    current: current,
    next: next,
    previous: previous
  });
  var style = {
    height: 'fit-content',
    position: 'absolute',
    transition: "left ".concat(DEFAULT_SLIDE_DURATION_MS, "ms cubic-bezier(0.42, 0, 0.58, 1)"),
    top: '0%'
  };
  var offsetValue = 0;
  if (current) {
    offsetValue = (index - (activePage - 1) * pageSize) / pageSize;
  } else if (previous) {
    offsetValue = (index - (previousPage - 1) * pageSize) / pageSize - 1;
  } else if (next) {
    offsetValue = (index - (nextPage - 1) * pageSize) / pageSize + 1;
  }
  if (hidden) {
    style = _objectSpread(_objectSpread({}, style), {}, {
      visibility: 'hidden',
      opacity: 0
    });
  } else {
    style = _objectSpread(_objectSpread({}, style), {}, {
      left: "".concat(offsetValue * 100, "%")
    });
  }
  return {
    className: className,
    style: style
  };
}
export function getSlide(slide, isMobile, displayAllMobile) {
  if (isMobile && displayAllMobile) {
    return false;
  }
  return slide;
}